import { useCallback, useEffect, useRef } from "react";
import { trackPiece } from "../trackerBus";

const DWELL_INTERVAL_MS = 30_000;

/** Tempo na vitrine /auctions (lista ao vivo). */
export function useAuctionListTracker(active) {
  const enterRef = useRef(null);

  const secondsOnList = useCallback(() => {
    if (!enterRef.current) return 0;
    return Math.round((Date.now() - enterRef.current) / 1000);
  }, []);

  const trackList = useCallback(
    (eventType, extra = {}) => {
      trackPiece(eventType, {
        page: "/auctions",
        duration_seconds: extra.duration_seconds ?? secondsOnList(),
        ...extra,
      });
    },
    [secondsOnList],
  );

  useEffect(() => {
    if (!active) return undefined;

    enterRef.current = Date.now();
    trackList("auction_list_enter");

    const dwellId = setInterval(() => {
      if (document.hidden) return;
      trackList("auction_list_dwell");
    }, DWELL_INTERVAL_MS);

    return () => {
      clearInterval(dwellId);
      trackList("auction_list_leave");
      enterRef.current = null;
    };
  }, [active, trackList]);

  return { trackList, secondsOnList };
}
